module.exports = __webpack_public_path__ + "media/images/recruitment/designs/alpha-phi-rainbow-bg-20bc253fe6bce846baafdc2f351a26ef.jpg";